import { Injectable } from '@angular/core';
import { TempCreateExpressApisModel } from '../../models/express/express';
import { TempCreateExpressModel } from '../../view-models/express';
import { Mapper } from '../mapper';

@Injectable({
    providedIn: 'root'
})
export class CreateTempExpressMapper implements Mapper<TempCreateExpressApisModel, TempCreateExpressModel>  {
    constructor(

    ) { }
    mapForm(param: TempCreateExpressApisModel): TempCreateExpressModel {
        return {
            administrativeCourt: param.c_ID,
            blackNumberCase: param.seC_ID,
            suitID: param.suiT_ID,
            fdTID: param.fdT_ID,
            reQID: param.reQID

        }
    }

    mapTo(param: TempCreateExpressModel): TempCreateExpressApisModel {
        return {
            c_ID: param.administrativeCourt,
            seC_ID: param.blackNumberCase,
            suiT_ID: param.suitID,
            fdT_ID: param.fdTID,
            reQID: param.reQID
        }
    }

} 